import { FC, Modal, useMemo} from 'external/react'
import useParent from 'context/parent-context/hook'

type PackageModalHeaderProps = {
  index: false | number
}

const PackageModalHeader:FC<PackageModalHeaderProps> = props => {

  const {index} = props
  const {state: {payments}} = useParent()
  const payment = useMemo(() => index === false ? {} as any : payments.items[index], [index])

  const {offerName, plan_alias} = payment

  return (
      <Modal.Header closeButton>
        <h5 className='text-capitalize' style={{ fontFamily: 'Arial, sans-serif', margin: '0' }}>
          {`Plan ${offerName}`}
          <span className='fn-s-14 ml-1'>{`(${plan_alias})`}</span>
        </h5>
      </Modal.Header>
  )
}

export {PackageModalHeader as default}